import { render, staticRenderFns } from "./DialogAddEditTeam.vue?vue&type=template&id=3bd5e60c"
import script from "./DialogAddEditTeam.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditTeam.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports